import queryString from 'query-string';

export function initQueryParams(cb) {
    const parsedQueryString = queryString.parse(window.location.search);
    return parsedQueryString ? cb(null, parsedQueryString) : cb('No Query String', null);
}